// store/modules/app.js
import {
  loginGly as loginGlyApi,
  loginFwzCode as loginFwzCodeApi,
  loginkingdee as loginkingdeeApi
} from '@/api/login'
import { Message } from '@arco-design/web-vue'
import router from '@/router'
import { setTokenTime } from '@/utils/auth'
import { getFirstMenuPath, toRoutePath } from '@/utils/menu'
import jsonwebtoken from 'jsonwebtoken'

function navigateAfterLogin(menus) {
  const routePath = toRoutePath(getFirstMenuPath(menus))
  sessionStorage.setItem('path', routePath)
  router.replace(routePath)
}

export default {
  namespaced: true,
  state: () => ({
    // 当前版本 v1.0.11
    token: '', // 不再需要从localStorage初始化
    menuList: [],
    siderType: true,
    lang: 'zh',
    projectSign: process.env.VUE_APP_PROJECT_SIGN || 'kingdee',
    cangGuanSign:
      process.env.NODE_ENV === 'development'
        ? '开发'
        : process.env.VUE_APP_CANG_GUAN_SIGN || '生产',
    logginIdentity: '', // 登录身份：根据 userInfo 中的信息动态计算 Kingdee : 仓储中心登录  store :  服务站登录  gly : 管理员登录
    userInfo: null
  }),
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setMenu(state, menuList) {
      state.menuList = menuList
      localStorage.setItem('menuList', JSON.stringify(menuList))
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      console.log('app.js--->', userInfo)
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      // 根据用户信息自动判断登录身份
      // 根据job判断登录身份 job : 渔场
      if (userInfo && userInfo.sign === 'Kingdee') {
        state.logginIdentity = 'Kingdee' // 仓储中心登录
      } else if (userInfo.job === '售后' || userInfo.job === '销售') {
        state.logginIdentity = 'store' // 服务站登录
      } else if (userInfo.job === '渔场') {
        state.logginIdentity = 'fish' // 渔场登录
      } else if (userInfo) {
        state.logginIdentity = 'gly' // 管理员登录
      } else {
        state.logginIdentity = '' // 未登录或信息不全
      }
      console.log('state.logginIdentity--->', state.logginIdentity)
    },
    changeSiderType(state) {
      state.siderType = !state.siderType
    },
    changLang(state, lang) {
      state.lang = lang
    },
    // 新增：清除状态
    clearState(state) {
      state.token = ''
      state.userInfo = null
      state.menuList = []
      state.logginIdentity = ''
    }
  },
  actions: {
    // 初始化应用状态（可选，现在插件会自动处理）
    initApp({ commit }) {
      // 现在这个action可以保留为空，或者用于其他初始化逻辑
      console.log('应用初始化')
    },

    // 统一登录
    loginGly({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginGlyApi(userInfo)
          .then((res) => {
            console.log(res)
            if (res.status === 'success') {
              resolve(res.data)
            } else {
              Message.error(res.description)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // 输入验证码
    fwzloginCode({ commit }, codeInfo) {
      return new Promise((resolve, reject) => {
        var codeData = {
          code: codeInfo.code,
          phone: codeInfo.phone,
          account: codeInfo.accountValue
        }
        loginFwzCodeApi(codeData)
          .then((res) => {
            if (res.status === 'success') {
              commit('setToken', res.accesstoken)
              commit('setMenu', res.menus ? res.menus : [])
              setTokenTime()

              // 解析JWT
              const userinfo = jsonwebtoken.decode(res.idtoken)
              commit('setUserInfo', userinfo) // 这里会自动设置 logginIdentity

              navigateAfterLogin(res.menus)
            } else {
              Message.error(res.description)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // 仓储中心登录
    loginkingdee({ commit }, userInfo) {
      console.log('loginkingdee接受的参数--->', userInfo)

      return new Promise((resolve, reject) => {
        loginkingdeeApi(userInfo)
          .then((res) => {
            console.log('loginkingdeeRes--->', res)
            if (res.status === 'success') {
              var resData = res.data
              if (!resData.menus || resData.menus.length === 0) {
                Message.error('未开通权限，无法登录')
                reject(new Error('未开通权限，无法登录'))
                return
              }
              // var menus = [
              //   // {
              //   //   authName: '入库管理',
              //   //   id: 1,
              //   //   path: null,
              //   //   remark: null,
              //   //   children: [
              //   //     {
              //   //       authName: '入库信息列表',
              //   //       children: [],
              //   //       id: 2,
              //   //       path: 'RuKuInfoList'
              //   //     },
              //   //     {
              //   //       authName: '入库日志',
              //   //       children: [],
              //   //       id: 3,
              //   //       path: 'RuKuLog'
              //   //     }
              //   //   ]
              //   // },
              //   // {
              //   //   authName: '出库管理',
              //   //   id: 2,
              //   //   path: null,
              //   //   remark: null,
              //   //   children: [
              //   //     {
              //   //       authName: '出库信息列表',
              //   //       children: [],
              //   //       id: 4,
              //   //       path: 'ChuKuInfoList'
              //   //     },
              //   //     {
              //   //       authName: '出库日志',
              //   //       children: [],
              //   //       id: 5,
              //   //       path: 'ChuKuLog'
              //   //     }
              //   //   ]
              //   // },
              //   {
              //     authName: '商品管理',
              //     id: 3,
              //     path: null,
              //     remark: null,
              //     children: [
              //       {
              //         authName: '商品管理',
              //         children: [],
              //         id: 6,
              //         path: 'goodsPage'
              //       }
              //     ]
              //   },
              //   {
              //     authName: '订单管理',
              //     id: 4,
              //     path: null,
              //     remark: null,
              //     children: [
              //       {
              //         authName: '订单列表',
              //         children: [],
              //         id: 7,
              //         path: 'CGordersList'
              //       }
              //     ]
              //   }
              //   // {
              //   //   authName: '客户信息',
              //   //   id: 5,
              //   //   path: null,
              //   //   remark: null,
              //   //   children: [
              //   //     {
              //   //       authName: '客户列表',
              //   //       children: [],
              //   //       id: 9,
              //   //       path: 'CGCustomerList'
              //   //     }
              //   //   ]
              //   // }
              // ]
              commit('setToken', resData.accesstoken)
              commit('setMenu', resData.menus)
              setTokenTime()

              // 解析JWT
              const userinfo = jsonwebtoken.decode(resData.idtoken)
              commit('setUserInfo', userinfo) // 这里会自动设置 logginIdentity

              navigateAfterLogin(resData.menus)
            } else {
              Message.error(res.description || '登录失败')
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // 退出登录
    logout({ commit }) {
      commit('clearState')
      sessionStorage.setItem('path', '/homepage')
      // 插件会自动同步清除localStorage中的数据
      window.location.reload()
    }
  },
  getters: {
    // 获取登录身份显示文本
    loginIdentityText: (state) => {
      switch (state.logginIdentity) {
        case 'Kingdee':
          return '仓储中心'
        case 'store':
          return '服务站'
        case 'gly':
          return '管理员'
        case 'fish':
          return '渔场'
        default:
          return '未知身份'
      }
    },

    // 用户身份判断
    isPlatform: (state) => state.logginIdentity === 'gly', // 平台管理员
    isServiceStation: (state) => state.logginIdentity === 'store', // 服务站
    isWarehouse: (state) => state.logginIdentity === 'Kingdee', // 仓储中心
    isFish: (state) => state.logginIdentity === 'fish', // 渔场

    // 用户信息
    userInfo: (state) => state.userInfo,
    storeId: (state) => state.userInfo?.storeId,

    // 登录状态判断
    isLoggedIn: (state) => !!state.token && !!state.userInfo
  }
}
